module.exports = __webpack_public_path__ + "static/media/11_venture.d33fdf0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/scrap-step/press/11_venture.png
// module id = 532
// module chunks = 0